import React, { useEffect, useState } from "react";

const BannerBottomEditor = () => {
  const [formData, setFormData] = useState({
    id: 1,
    background_image: [],
    main_heading: "",
    main_description: "",
    button_text: "",
    button_link: "",
    status: "inactive",
  });

  const [previewImage, setPreviewImage] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    fetchBannerBottom();
  }, []);

  const normalizeStatus = (value) => {
    if (
      value === "active" ||
      value === 1 ||
      value === "1" ||
      value === true ||
      value === "true"
    ) {
      return "active";
    }
    return "inactive";
  };

  const fetchBannerBottom = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await fetch(
        "https://eventscons.com/eventbackendnew/api/banner-bottom-details?id=1"
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (result.status && result.data) {
        const currentStatus =
          result.data.status ??
          result.data.is_active ??
          result.data.banner_status ??
          "inactive";

        setFormData({
          id: result.data.id || 1,
          background_image: result.data.background_image || [],
          main_heading: result.data.main_heading || "",
          main_description: result.data.main_description || "",
          button_text: result.data.button_text || "",
          button_link: result.data.button_link || "",
          status: normalizeStatus(currentStatus),
        });

        setPreviewImage(
          Array.isArray(result.data.background_image)
            ? result.data.background_image[0] || ""
            : result.data.background_image || ""
        );
      } else {
        throw new Error(result.message || "Failed to fetch banner bottom details");
      }
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewImage(imageUrl);

      setFormData((prev) => ({
        ...prev,
        background_image: [file],
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage("");
    setError("");

    try {
      const payload = new FormData();

      payload.append("id", formData.id);
      payload.append("main_heading", formData.main_heading || "");
      payload.append("main_description", formData.main_description || "");
      payload.append("button_text", formData.button_text || "");
      payload.append("button_link", formData.button_link || "");

      if (
        formData.background_image &&
        formData.background_image.length > 0 &&
        formData.background_image[0] instanceof File
      ) {
        payload.append("background_image", formData.background_image[0]);
      }

      const response = await fetch(
        "https://eventscons.com/eventbackendnew/api/banner-bottom-update",
        {
          method: "POST",
          body: payload,
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Banner bottom update failed");
      }

      setMessage(result.message || "Banner bottom updated successfully");
      await fetchBannerBottom();
    } catch (err) {
      setError(err.message || "Something went wrong while updating");
    } finally {
      setSubmitting(false);
    }
  };

  const handleStatusChange = async (e) => {
    const selectedStatus = e.target.value;

    setFormData((prev) => ({
      ...prev,
      status: selectedStatus,
    }));

    try {
      setStatusLoading(true);
      setMessage("");
      setError("");

      const payload = new FormData();
      payload.append("id", formData.id);
      payload.append("status", selectedStatus);

      const response = await fetch(
        "https://eventscons.com/eventbackendnew/api/banner-bottom-status",
        {
          method: "POST",
          body: payload,
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Status update failed");
      }

      setMessage(result.message || `Status changed to ${selectedStatus}`);
      await fetchBannerBottom();
    } catch (err) {
      setError(err.message || "Something went wrong while updating status");

      setFormData((prev) => ({
        ...prev,
        status: prev.status === "active" ? "inactive" : "active",
      }));
    } finally {
      setStatusLoading(false);
    }
  };

  if (loading) {
    return <p style={styles.loading}>Loading banner bottom details...</p>;
  }

  if (error && !formData.main_heading) {
    return <p style={styles.error}>{error}</p>;
  }

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={styles.topBar}>
          <div>
            <h2 style={styles.heading}>Banner Bottom Section</h2>
           
          </div>

          <div style={styles.statusCard}>
            {/* <label style={styles.statusLabel}>Status</label> */}

            <div
              style={{
                ...styles.selectWrap,
                borderColor:
                  formData.status === "active" ? "#22c55e" : "#d1d5db",
                background:
                  formData.status === "active"
                    ? "linear-gradient(135deg, #f0fdf4, #dcfce7)"
                    : "linear-gradient(135deg, #ffffff, #f9fafb)",
              }}
            >
              <span
                style={{
                  ...styles.statusDot,
                  background:
                    formData.status === "active" ? "#22c55e" : "#9ca3af",
                  boxShadow:
                    formData.status === "active"
                      ? "0 0 0 4px rgba(34,197,94,0.12)"
                      : "0 0 0 4px rgba(156,163,175,0.12)",
                }}
              />

              <select
                value={formData.status}
                onChange={handleStatusChange}
                style={styles.select}
                disabled={statusLoading}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>

              {/* <span style={styles.selectArrow}>⌄</span> */}
            </div>

            
          </div>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.imageBox}>
            <label style={styles.label}>Banner Background Image</label>

            {previewImage ? (
              <img
                src={previewImage}
                alt="Banner Bottom Preview"
                style={styles.image}
              />
            ) : (
              <div style={styles.noImageBox}>No image selected</div>
            )}

            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={styles.input}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Banner Title</label>
            <input
              type="text"
              name="main_heading"
              value={formData.main_heading}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter banner title"
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Banner Text</label>
            <textarea
              name="main_description"
              value={formData.main_description}
              onChange={handleChange}
              rows="5"
              style={styles.textarea}
              placeholder="Enter banner text"
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Banner Button Text</label>
            <input
              type="text"
              name="button_text"
              value={formData.button_text}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter button text"
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Banner Button Link</label>
            <input
              type="text"
              name="button_link"
              value={formData.button_link}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter button link"
            />
          </div>

          {statusLoading && <p style={styles.info}>Updating status...</p>}
          {message && <p style={styles.success}>{message}</p>}
          {error && <p style={styles.error}>{error}</p>}

          <button type="submit" style={styles.button} disabled={submitting}>
            {submitting ? "Saving..." : "Update Banner Bottom"}
          </button>
        </form>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "32px",
    background: "linear-gradient(180deg, #ffffff 0%, #fafafa 100%)",
    margin: "30px",
    borderRadius: "24px",
    border: "1px solid #ececec",
    boxShadow: "0 20px 45px rgba(15, 23, 42, 0.08)",
  },
  container: {
    maxWidth: "1040px",
    margin: "0 auto",
  },
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "20px",
    marginBottom: "28px",
    flexWrap: "wrap",
    paddingBottom: "20px",
    borderBottom: "1px solid #f1f1f1",
  },
  heading: {
    margin: 0,
    fontSize: "30px",
    fontWeight: "800",
    color: "#111827",
    letterSpacing: "-0.4px",
    textAlign:'left',
  },
  subHeading: {
    margin: "8px 0 0 0",
    color: "#6b7280",
    fontSize: "15px",
    fontWeight: "500",
  },
  // statusCard: {
  //   minWidth: "240px",
  //   background: "#fff",
  //   border: "1px solid #ececec",
  //   borderRadius: "18px",
  //   padding: "16px",
  //   boxShadow: "0 10px 25px rgba(15,23,42,0.06)",
  //   display: "flex",
  //   flexDirection: "column",
  //   gap: "10px",
  // },
  statusLabel: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#374151",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  selectWrap: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    border: "1px solid #d1d5db",
    borderRadius: "14px",
    padding: "0 14px",
    minHeight: "50px",
    position: "relative",
    transition: "all 0.25s ease",
  },
  statusDot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    flexShrink: 0,
  },
  select: {
    flex: 1,
    border: "none",
    outline: "none",
    background: "transparent",
    fontSize: "15px",
    fontWeight: "700",
    color: "#111827",
    cursor: "pointer",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    padding: "12px 26px 12px 0",
  },
  selectArrow: {
    position: "absolute",
    right: "14px",
    fontSize: "18px",
    color: "#6b7280",
    pointerEvents: "none",
    lineHeight: 1,
  },
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    padding: "8px 12px",
    borderRadius: "999px",
    fontSize: "13px",
    fontWeight: "700",
    border: "1px solid",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "22px",
  },
  imageBox: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "18px",
    background: "#fcfcfc",
    border: "1px solid #eeeeee",
    borderRadius: "18px",
  },
  image: {
    width: "100%",
    maxWidth: "620px",
    height: "300px",
    objectFit: "cover",
    borderRadius: "16px",
    border: "1px solid #e5e7eb",
    boxShadow: "0 12px 24px rgba(0,0,0,0.08)",
  },
  noImageBox: {
    width: "100%",
    maxWidth: "620px",
    height: "240px",
    border: "1.5px dashed #cbd5e1",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#6b7280",
    background: "linear-gradient(180deg, #f9fafb 0%, #f3f4f6 100%)",
    fontWeight: "600",
    fontSize: "15px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "9px",
  },
  label: {
    fontWeight: "700",
    color: "#1f2937",
    fontSize: "14px",
  },
  input: {
    padding: "14px 16px",
    borderRadius: "14px",
    border: "1px solid #d1d5db",
    fontSize: "15px",
    width: "100%",
    outline: "none",
    background: "#fff",
    color: "#111827",
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
  },
  textarea: {
    padding: "14px 16px",
    borderRadius: "14px",
    border: "1px solid #d1d5db",
    fontSize: "15px",
    resize: "vertical",
    width: "100%",
    minHeight: "140px",
    outline: "none",
    background: "#fff",
    color: "#111827",
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
  },
  button: {
    padding: "14px 22px",
    background: "linear-gradient(135deg, #9B1321 0%, #7f0f1b 100%)",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    fontSize: "15px",
    fontWeight: "700",
    cursor: "pointer",
    width: "fit-content",
    boxShadow: "0 12px 20px rgba(155, 19, 33, 0.25)",
  },
  success: {
    color: "#166534",
    background: "#ecfdf5",
    border: "1px solid #bbf7d0",
    padding: "12px 14px",
    borderRadius: "12px",
    fontWeight: "700",
  },
  error: {
    color: "#991b1b",
    background: "#fef2f2",
    border: "1px solid #fecaca",
    padding: "12px 14px",
    borderRadius: "12px",
    fontWeight: "700",
  },
  info: {
    color: "#1d4ed8",
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    padding: "12px 14px",
    borderRadius: "12px",
    fontWeight: "700",
  },
  loading: {
    padding: "40px",
    textAlign: "center",
    color: "#374151",
    fontWeight: "600",
  },
};

export default BannerBottomEditor;